module.exports = __webpack_public_path__ + "img/gift-icon.968bf976.svg";